module.exports = __webpack_public_path__ + "img/section-3-content_1_t_icon4_native.dddd1b83.png";